import React from "react";
import { useReactAppState } from "../../../shared/containers/utils";
import {
  composeGeoLocatedProviders,
  stringifyProviders,
} from "../../../shared/utils";
import { statusTypes, useMatchData } from "../../utils";
import {
  StyledMatchBroadcaster,
  StyledMatchBroadcasterLabel,
  StyledMatchBroadcasterStringified,
  StyledMatchBroadcasterStringifiedWrapper,
} from "./StyledMatchBroadcaster";
import { composeAppleProviders } from "./utils";

export const MatchBroadcaster = () => {
  const { location } = useReactAppState();
  const { country } = location || {};
  const { mediaProviders, status } = useMatchData() || {};

  const appleProviders =
    composeAppleProviders(mediaProviders?.allProvidersList) || [];

  const { national, streaming, radio } =
    status?.abbreviation === statusTypes.pre ||
    status?.abbreviation === statusTypes.live
      ? composeGeoLocatedProviders(mediaProviders, country)
      : { national: null, streaming: null, radio: null };

  const broadcastersProviders = national?.length
    ? national
    : streaming?.length
    ? streaming
    : radio?.length
    ? radio
    : [];

  const stringifiedProviders = stringifyProviders([
    ...appleProviders,
    ...broadcastersProviders,
  ]);

  return (
    <StyledMatchBroadcaster
      className="mls-c-match-list__match-broadcaster"
      title={stringifiedProviders}
    >
      {stringifiedProviders &&
        (status?.abbreviation === statusTypes.live ||
          status?.abbreviation === statusTypes.pre) && (
          <StyledMatchBroadcasterLabel>
            <StyledMatchBroadcasterStringifiedWrapper className="mls-c-match-list__broadcaster">
              <StyledMatchBroadcasterStringified>
                {stringifiedProviders}
              </StyledMatchBroadcasterStringified>
            </StyledMatchBroadcasterStringifiedWrapper>
          </StyledMatchBroadcasterLabel>
        )}
    </StyledMatchBroadcaster>
  );
};
